import { Fragment } from "react";

import { TableLoader } from "../molecules/TableLoader";
import ColumnText from "../molecules/ColumnText";
import { Empty } from "./Empty";

export type AgreementsSummaryTableProps = {
  isLoading: boolean;
  agreements: any[];
};

export const AgreementsSummaryTable: React.FC<AgreementsSummaryTableProps> = ({
  isLoading,
  agreements,
}) => {
  return (
    <div className="flex-1 overflow-scroll flex flex-col border">
      <div className="flex flex-1 flex-col">
        {isLoading ? (
          <TableLoader columns={4} />
        ) : (
          <Fragment>
            {agreements.length === 0 ? (
              <Empty texto={`No hay convenios de empresa`} />
            ) : (
              <Fragment>
                <table className="divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        DNI / RUT
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Usuario
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Producto
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Monto
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Moneda
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        Fecha
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {agreements.map((agreement: any) => {
                      return (
                        <tr key={agreement.id}>
                          <ColumnText wrap title={agreement?.user?.name} />
                          <ColumnText wrap title={agreement?.user?.name} />
                          <ColumnText wrap title={agreement?.fee?.name} />
                          <ColumnText
                            wrap
                            title={agreement?.amountDiscount.toFixed(2) / 100}
                          />
                          <ColumnText
                            wrap
                            title={agreement.fee?.currency?.toUpperCase()}
                          />
                          <ColumnText wrap title={agreement.dateInit} />
                        </tr>
                      );
                    })}
                    {/* Fila de totales */}
                    <tr className="bg-gray-50 font-semibold">
                      <td className="px-3 py-3.5"></td>
                      <td className="px-3 py-3.5 text-sm text-gray-900">
                        <strong>Total:</strong>
                      </td>
                      <td className="px-3 py-3.5"></td>
                      <td className="px-3 py-3.5 text-sm text-gray-900">
                        <strong>
                          {(() => {
                            const total = agreements.reduce(
                              (sum, agreement) => {
                                return sum + agreement.amountDiscount;
                              },
                              0
                            );
                            return (total / 100).toFixed(2);
                          })()}
                        </strong>
                      </td>
                      <td className="px-3 py-3.5"></td>
                      <td className="px-3 py-3.5"></td>
                    </tr>
                  </tbody>
                </table>
              </Fragment>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default AgreementsSummaryTableProps;
